var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockRotate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0834 7.58398C12.2894 7.58398 10.8334 9.03999 10.8334 10.834V13.0007H9.75006V19.5007H18.4168V13.0007H17.3334V10.834C17.3334 9.03999 15.8774 7.58398 14.0834 7.58398ZM16.2501 13.0007H11.9167V10.834C11.9167 9.63908 12.8885 8.66732 14.0834 8.66732C15.2783 8.66732 16.2501 9.63908 16.2501 10.834V13.0007Z",
    fill: "#808693"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0834 0C6.30503 0 0 6.30503 0 14.0834C0 21.8618 6.30503 28.1668 14.0834 28.1668C17.9726 28.1668 21.4935 26.5905 24.0415 24.0414L23.2712 23.2712C20.9182 25.6253 17.6682 27.0835 14.0834 27.0835C6.91495 27.0835 1.08334 21.2519 1.08334 14.0834C1.08334 6.91495 6.91495 1.08334 14.0834 1.08334C21.2519 1.08334 27.0835 6.91495 27.0835 14.0834H24.9168L27.6251 17.3334L30.3335 14.0834H28.1668C28.1668 6.30503 21.8618 0 14.0834 0Z",
    fill: "#808693"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockRotate);
export default __webpack_public_path__ + "static/media/block_rotate.48b465faa8cb49eb65efd0fabd89cd61.svg";
export { ForwardRef as ReactComponent };